// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gP4c","label":"styles_label__1vmvT"};